import React, { Component } from 'react';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Downshift from 'downshift';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography'

function renderInput(inputProps) {
  const { InputProps, classes, ref, ...other } = inputProps;

  return (
    <TextField
      inputProps={{ autocomplete: 'off' }}
      InputProps={{
        inputRef: ref,
        classes: {
          root: classes.inputRoot,
        },
        ...InputProps,
      }}
      {...other}
    />
  );
}

function renderSuggestion({ suggestion, labelKey = 'label', index, itemProps, highlightedIndex, selectedItem, onClick}) {
  const isHighlighted = highlightedIndex === index;
  const isSelected = (selectedItem || '').indexOf(suggestion[labelKey]) > -1;

  return (
    <MenuItem
      {...itemProps}
      key={suggestion[labelKey]}
      selected={isHighlighted}
      onMouseUp={() => onClick(suggestion)}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
      }}
    >
      <Typography type='caption'>{suggestion[labelKey]}</Typography>
    </MenuItem>
  );
}
renderSuggestion.propTypes = {
  highlightedIndex: PropTypes.number,
  index: PropTypes.number,
  itemProps: PropTypes.object,
  labelKey: PropTypes.string,
  selectedItem: PropTypes.string,  
  suggestion: PropTypes.object.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  container: {
    flexGrow: 1,
    position: 'relative',
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  inputRoot: {
    flexWrap: 'wrap',
  },
});

let popperNode;

class Autocomplete extends Component {
  handleClick = item => {
    const { onClick } = this.props
    const { latitude, longitude } = item
    const center = [longitude, latitude]
    const zoom = [15]

    console.log(this.state)
    onClick(center, zoom)
  }

  getSuggestions(inputValue) {
    const { suggestions, labelKey = 'label' } = this.props
    let count = 0;

    return suggestions.filter(suggestion => {
      const keep =
            (!inputValue || suggestion[labelKey].toLowerCase().indexOf(inputValue.toLowerCase()) !== -1) &&
            count < 5;

      if (keep) {
        count += 1;
      }

      return keep;
    });
  }

  render () {
    const { classes, labelKey = 'label' } = this.props;

    return (
      <div className={classes.root}>
        <Downshift>
          {({ getInputProps, getItemProps, isOpen, inputValue, selectedItem, highlightedIndex }) => (
            <div className={classes.container}>
              {renderInput({                
                autofill: 'off',
                fullWidth: true,
                classes,
                InputProps: getInputProps({
                  placeholder: 'Search',
                  id: 'search',
                  autofill: 'off'
                }),
                ref: node => {
                  popperNode = node;
                },
              })}
              <Popper open={isOpen} anchorEl={popperNode} style={{ zIndex: 2000 }} >
                <Paper square style={{ width: popperNode ? popperNode.clientWidth : null }}>
                  {this.getSuggestions(inputValue).map((suggestion, index) =>
                    renderSuggestion({
                      suggestion,
                      labelKey,
                      index,
                      itemProps: getItemProps({ item: suggestion[labelKey] }),
                      highlightedIndex,
                      selectedItem,
                      onClick: this.handleClick
                    }),
                  )}
                </Paper>
              </Popper>
            </div>
          )}
        </Downshift>
      </div>
    );
  }
}

Autocomplete.propTypes = {
  classes: PropTypes.object.isRequired,
  labelKey: PropTypes.string
};

export default withStyles(styles)(Autocomplete);



// WEBPACK FOOTER //
// ./src/components/Autocomplete.js